<template>
  <div id="instructions-list">
    <ol v-if="selectedStore === PaymentMethod.bancolombia">
      <li class="instructions-element">
        {{ t("BANCOLOMBIAINSTRUCTIONONE") }}
      </li>
      <li class="instructions-element">
        {{ t("BANCOLOMBIAINSTRUCTIONTWO") }}
      </li>
      <li class="instructions-element">
        {{ t("BANCOLOMBIAINSTRUCTIONTHREE") }}
      </li>
    </ol>
    <ol v-if="selectedStore === PaymentMethod.efecty">
      <li class="instructions-element">
        {{ t("EFECTYINSTRUCTIONONE") }}
      </li>
      <li class="instructions-element">
        {{ t("EFECTYINSTRUCTIONTWO") }}
      </li>
      <li class="instructions-element">
        {{ t("EFECTYINSTRUCTIONTHREE") }}
      </li>
    </ol>
    <ol v-if="selectedStore === PaymentMethod.refacil">
      <li class="instructions-element">
        {{ t("REFACILINSTRUCTIONONE") }}
      </li>
      <li class="instructions-element">
        {{ t("REFACILINSTRUCTIONTWO") }}
      </li>
      <li class="instructions-element">
        {{ t("REFACILINSTRUCTIONTHREE") }}
      </li>
    </ol>
    <ol v-if="selectedStore === PaymentMethod.movii">
      <li class="instructions-element">
        {{ t("MOVIIINSTRUCTIONONE") }}
      </li>
      <li class="instructions-element">
        {{ t("MOVIIINSTRUCTIONTWO") }}
      </li>
      <li class="instructions-element">
        {{ t("MOVIIINSTRUCTIONTHREE") }}
      </li>
      <li class="instructions-element">
        {{ t("MOVIIINSTRUCTIONFOUR") }}
      </li>
    </ol>
  </div>
</template>

<script setup lang="ts">
import { inject } from "vue";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import { PaymentMethod } from "@/apps/credit-line/types/payment";

const { t } = useI18n();
const selectedStore = inject("selectedStore");
</script>

<style scoped lang="scss"></style>
